import makeStyles from "@mui/styles/makeStyles";
import { Stack, styled } from "@mui/material";

export const MainStack = styled(Stack)(({ theme }) => ({
  height: "100%",
  width: "100%",
  display: "flex",
  backgroundColor: "#F3F4F7",
  padding: "100px 120px",
  [theme.breakpoints.down("lg")]: {
    padding: "60px 40px",
  },
}));

const styles = makeStyles(() => ({
  container: {
    height: "100vh",
    width: "100vw",
    position: "absolute",
  },
}));

export default styles;
